import React, { useState, useEffect, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Dropdown } from 'react-bootstrap';
import moment from 'moment';

import { getgendersdisplay, getProgramType, isProd } from '../../helper';
import { programFavourite } from '../../services/programService';
import { LogoWhite, StoreIcon } from '../reuse/SVG';
import { useAdditionalExperience } from "../../context/AdditionalExperienceContext";
import Share from '../static/Share';


const getProgramPriceByDates = (allPrices, selectedDateByProgram) => {
    const _res = allPrices.filter(el => selectedDateByProgram.find((id) => el._id === id));
    let _totalPrice = 0;
    if(_res.length){
        _res.map(i => _totalPrice += i.standardPrice)
    }

    if(_totalPrice > 0){
        return `Price: $${_totalPrice.toFixed(2)}`
    }else{
        return 'Free'
    }
}


const BookingCard = props => {
    const [isFavourite, setIsFavourite] = useState('');
    const [programId, setProgramId] = useState('');
    const [bookingType, setBookingType] = useState('');
    const [bookingId, setBookingId] = useState('');
    const [programImage, setProgramImage] = useState('');
    const [programName, setProgramName] = useState('');
    const [campName, setCampName] = useState('');
    const [startDateFormatted, setStartDateFormatted] = useState('');
    const [endDateFormatted, setEndDateFormatted] = useState('');
    const [programType, setProgramType] = useState('');
    const [checkInTime, setCheckInTime] = useState('');
    const [checkOutTime, setCheckOutTime] = useState('');
    const [gender, setGender] = useState('');
    const [ageGroup, setAgeGroup] = useState('');
    const [registrationFee, setRegistrationFee] = useState(0);
    const [bookingDate, setBookingDate] = useState('');
    const [bookingNumber, setBookingNumber] = useState('');
    const [pdf, setPdf] = useState('');
    const [byDates, setByDates] = useState(2);
    const [additionalDates, setAdditionalDates] = useState([]);
    const [selectedDates, setSelectedDates] = useState([]);

    const { openModal } = useAdditionalExperience();

    const handleAddAdditionalExperience = (e) => {
        e.preventDefault();
        e.stopPropagation();
        openModal({
            bookingId: props.data._id,
            programId: props.data.programId
        });
    };

    useEffect(() => {
            setIsFavourite(props.data.isFavourite); 
            setProgramId(props.data.programId); 
            setBookingType(props.bookingType); 
            setBookingId(props.data._id); 
            setProgramImage(props.data.programImage); 
            setProgramName(props.data.programName); 
            setStartDateFormatted(props.data.startDateFormatted);
            setEndDateFormatted(props.data.endDateFormatted);
            setProgramType(props.data.programType); 
            setCheckInTime(props.data.checkInTime); 
            setCheckOutTime(props.data.checkOutTime); 
            setGender(props.data.gender); 
            setAgeGroup(props.data.ageGroup); 
            setRegistrationFee(props.data.registrationFee === 'NaN' ? 0 : props.data.registrationFee); 
            setBookingDate(props.data.bookingDate); 
            setBookingNumber(props.data.bookingNumber); 
            setPdf(props.data.pdf); 
            setByDates(props.data.byDates);
            setAdditionalDates(props.data.additionalDates);
            setSelectedDates(props.data.selectedDates);
            setCampName(props.data.campName)


    }, [props.bookingType])


    const handleFavourite = (e) => {
        e.preventDefault()
        setIsFavourite(!isFavourite);
        let params = {
            programId,
            favourite: !isFavourite
        }
        programFavourite(params).then(res => {
            
        })
    }


        const handlePrint = (e, index) => {
          let allTabs = document.querySelectorAll(`.booking_page .booking_card`);
          for (let n = 0; n < allTabs.length; ++n) {
            allTabs[n].className = "card booking_card";
          }
          let elm = document.getElementById(`__print_${index}`);
          elm.className = "card booking_card booking_card_print";
          setTimeout(() => window.print(), 0)
        };



        const getSelectedDates = (_all, _sel) => {
            const _res = _all.filter(el => _sel.find((id) => el._id === id));
            return _res.map(i => (
            <span className='cm_selected_date' key={i._id}>
                {(() => {
                    const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                    const [sy, sm, sd] = (i.startDateFormatted || '').split('-').map(Number);
                    const [ey, em, ed] = (i.endDateFormatted || '').split('-').map(Number);
                    if (!sy) return '';
                    const sdStr = String(sd).padStart(2, '0');
                    const edStr = String(ed).padStart(2, '0');
                    if (sy === ey)
                        return `${months[sm - 1]} ${sdStr} - ${months[em - 1]} ${edStr}, ${sy}`;
                    return `${months[sm - 1]} ${sdStr}, ${sy} - ${months[em - 1]} ${edStr}, ${ey}`;
                })()}
            </span>
            ));
        }

    return (
        <div
            className={`card booking_card ${bookingType === 3 ? 'has_canceled' : ''}`}
            id={`__print_${programId}`}
        >
            {/* Top icons */}
            <div className="booking_icon_btns hide_on_print">
            {bookingType === 1 && (
                <Fragment>
                {pdf ? (
                    <a href={pdf} download>
                    <i className="icon-doc-check" />
                    </a>
                ) : null}

                {/* { bookingType === 2 && (
                    <i
                        className={`icon-heart${isFavourite ? '-fill' : ''}`}
                        onClick={handleFavourite}
                    />
                )} */}

                <Share pageUrl={`Booking=${bookingId}&ProgramId=${programId}`} />
                </Fragment>
            // ) : (
                // <i className="icon-heart" />
            )}
            </div>

            {/* MAIN BODY */}
            <div className="booking_card_body">
            {/* LEFT SIDE (clickable) */}
            <Link
                className="text-reset booking_left"
                to={`/booking/${bookingId}/${programId}`}
            >
                {programImage ? (
                <img src={programImage} alt="program" />
                ) : (
                <div className="no_img">
                    <LogoWhite />
                </div>
                )}

                <h3>{programName}</h3>

                {!isProd() && (
                <p>
                    <i>
                    <b>( {campName} )</b>
                    </i>
                </p>
                )}

                <div className="cm_about_booking">
                {byDates === 1 ? (
                    <p>{getSelectedDates(additionalDates, selectedDates)}</p>
                ) : (
                    <p>
                    Program Dates :{' '}
                    {programId === '621d3620c9cc80756fe0a171'
                        ? 'TBA'
                        : (() => {
                            const days = ['Sunday','Monday','Tuesday','Wednesday','Thursday','Friday','Saturday'];
                            const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
                            const [sy, sm, sd] = (startDateFormatted || '').split('-').map(Number);
                            const [ey, em, ed] = (endDateFormatted || '').split('-').map(Number);
                            if (!sy) return '';
                            const sDay = days[new Date(sy, sm - 1, sd).getDay()];
                            const eDay = days[new Date(ey, em - 1, ed).getDay()];
                            if (sy === ey && sm === em && sd === ed)
                                return `${months[sm - 1]} ${sd}, ${sy} (${sDay})`;
                            return `${months[sm - 1]} ${sd}, ${sy} - ${months[em - 1]} ${ed}, ${ey} ( ${sDay}-${eDay})`;
                        })()}
                    </p>
                )}

                <p>
                    Program Type : {programType ? getProgramType(programType) : ''}{' '}
                    &nbsp;&nbsp; Time : {checkInTime} - {checkOutTime}
                </p>

                <p>
                    Age : {ageGroup} &nbsp;&nbsp; Gender :{' '}
                    {gender ? getgendersdisplay(gender) : ''}
                </p>
                </div>
            </Link>

            {/* RIGHT SIDE (buttons & price) */}
            <div className="booking_right">
                <div className="booking_price">
                { bookingType === 1 && (
                    <div className="add_exp_btn_wrapper">
                        <button
                        className="btn btn-outline-primary add_exp_btn"
                        onClick={handleAddAdditionalExperience}
                        >
                            Add Additional Experience
                        </button>
                    </div>

                    
                )}

                { bookingType === 1 && (
                    <Link to={`/online-store`}>
                        <button className="btn btn-secondary btn-sm d-flex align-items-center">
                            <StoreIcon />
                            <b className="ms-1">Online Camp Store</b>
                        </button>
                    </Link>
                )}

                <p className="booking_amount">
                    <span>
                    {registrationFee
                        ? `Price: $${parseFloat(registrationFee).toFixed(2)}`
                        : 'Free'}
                    </span>
                </p>
                </div>
            </div>
            </div>

            {/* FOOTER */}
            <div className="booking_footer mt-3 hide_on_print">
            <div className="booking_date_numner">
                <p>Booking date: {moment(bookingDate).format('DD MMMM, YYYY')}</p>
                <p>Booking Number : {bookingNumber}</p>
            </div>

            {bookingType === 2 && (
                <div className="booking_actions">
                <Link
                    to={`/booking/${bookingId}/${programId}`}
                    className="me-2 btn-sm btn btn-primary rounded-0"
                >
                    Rate & Review
                </Link>
                <Link
                    to={`/profile/bookings/${programId}`}
                    className="btn btn-sm btn-primary rounded-0"
                >
                    <i className="icon-gallery" /> See photos
                </Link>
                </div>
            )}
            </div>
        </div>
    );
}

export default BookingCard;